/*
 * Public API Surface of ngx-local-storage
 */
export { LocalStorageModule } from './lib/local-storage.module';
export { LocalStorageService } from './lib/local-storage.service';
export { ILocalStorageServiceConfig } from './lib/local-storage.config.interface';
export { INotifyOptions } from './lib/notify-options.interface';
